import r1 from "../../assets/images/r1.jpg";
import r2 from "../../assets/images/r4.jpg";
import r3 from "../../assets/images/r3.jpg";
import SwiperCard from "./../SwiperCard";
import { FaArrowRight} from "react-icons/fa";


export default function Reiq() {
  return (
    <div className="rounded-e-lg  flex ">
      <div className="space-y-10 grid w-full ">
        {/**Top row */}
        <div className="grid sm:grid-cols-2 gap-10 md:gap-0 md:grid-cols-3 border-b-2 border-[#2e2d69]  py-3 w-full">
          {/**ReIQ informatin card */}
          <div className="flex w-full text-[10px] sm:text-xs items-center md:justify-center gap-8">
            <div className="p-4 m-auto space-y-5 rounded-lg bg-[#978b72]">
              <p className="text-[10px] sm:text-xs text-gray-300">
                Feedback and app testers welcome
              </p>
              <div className="w-full p-2 text-black rounded-md bg-[#eae0ce] transition ease-in-out duration-300 cursor-pointer hover:scale-105 hover:bg-[#eedec4]">
                <h1 className="md:text-xs font-bold">ReIQ.apk</h1>
                <div className="flex pt-1 justify-between">
                  <p className="">apk comming soon</p>
                  <FaArrowRight className="text-sm w-10 text-[#c78d41]" />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <h1 className="md:text-xs text-gray-800">Tech stack</h1>
                <div className="flex gap-2">
                  <div className="bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                    Kotlin
                  </div>
                  <div className="bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                    Jetpack Compose
                  </div>
                </div>
                <div className="flex gap-2 mt-1">
                  <div className="bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                    Python
                  </div>
                  <div className="bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                    Firebase
                  </div>
                  <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                    Cloud{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" md:col-span-2 items-center  pb-5 grid grid-flow-col gap-14 justify-center">
            <img
              src={r3}
              className="max-h-32 md:max-h-80 border bg-zinc-500 rounded-lg shadow-lg border-gray-800 object-contain"
            />
          
            <img
              src={r2}
              className="max-h-32 md:max-h-80 border bg-zinc-500 rounded-lg shadow-lg border-gray-800 object-contain"
            />
              <img
              src={r1}
              className="max-h-32 md:max-h-80 border bg-zinc-500 rounded-lg shadow-lg border-gray-800 object-contain"
            />
          </div>
        </div>
        {/**Bottom row */}
        <div className="flex items-center justify-center">
          <SwiperCard />
        </div>
      </div>
    </div>
  );
}
